// Application Insights Action Constants
// ===================================
// Centralized constants for all Application Insights tracking actions
// This ensures consistency across components and makes refactoring easier


export const AppInsightsActions = {
  // Authentication Actions
  LOGIN_ATTEMPT: "login-attempt",
  LOGIN_SUCCESS: "login-success",
  LOGIN_FAILURE: "login-failure",
  LOGOUT_ATTEMPT: "logout-attempt",
  LOGOUT_SUCCESS: "logout-success",
  AUTHENTICATION_CHECK: "authentication-check",
  AUTHENTICATION_SUCCESS: "authentication-success",
  AUTHENTICATION_FAILURE: "authentication-failure",
  HUMAN_VERIFICATION_ATTEMPT: "human-verification-attempt",
  HUMAN_VERIFICATION_SUCCESS: "human-verification-success",
  HUMAN_VERIFICATION_FAILURE: "human-verification-failure",
  FORM_SUBMIT_ATTEMPT: "form-submit-attempt",
  FORM_SUBMIT_SUCCESS: "form-submit-success",
  FORM_SUBMIT_FAILURE: "form-submit-failure",
  PAGE_VIEW: "page-view",
  ROUTE_CHANGE: "route-change",
  LOGOUT_FAILURE: "logout-failure",
  LOGOUT_API_FAILURE: "logout-api-failure",

  // Password Management Actions
  PASSWORD_RESET_ATTEMPT: "password-reset-attempt",
  PASSWORD_RESET_SUCCESS: "password-reset-success",
  PASSWORD_RESET_FAILURE: "password-reset-failure",
  PASSWORD_CHANGE_ATTEMPT: "password-change-attempt",
  PASSWORD_CHANGE_SUCCESS: "password-change-success",
  PASSWORD_CHANGE_FAILURE: "password-change-failure",

  // Registration Actions
  PAGE_VISIT: "page-visit",
  NAVIGATION_FORGOT_PASSWORD: "navigation-forgot-password",
  NAVIGATION_ALREADY_HAVE_ACCOUNT: "navigation-already-have-account",
  NAVIGATION_FAILURE: "navigation-failure",
  CANCEL_BUTTON_CLICK: "cancel-button-click",
  CANCEL_FAILURE: "cancel-failure",
  IFRAME_LOAD_SUCCESS: "iframe-load-success",
  IFRAME_LOAD_FAILURE: "iframe-load-failure",

  // Product Selection Actions
  PRODUCT_NAVIGATION: "product-navigation",
  NAVIGATION_FAILURE_PRODUCT: "navigation-failure",
  NO_SUBSCRIPTIONS: "no-subscriptions",
  SEASCAPE_BUTTON_FAILURE: "seascape-button-failure",
  HORIZON_BUTTON_FAILURE: "horizon-button-failure",

  // API and Network Actions
  API_REQUEST: "api-request",
  API_RESPONSE: "api-response",
  API_RESPONSE_ERROR: "api-response-error",
  API_REQUEST_FAILURE: "api-request-failure",
  API_REQUEST_SUCCESS: "api-request-success",
  TOKEN_REFRESH_ATTEMPT: "token-refresh-attempt",
  TOKEN_REFRESH_SUCCESS: "token-refresh-success",
  TOKEN_REFRESH_FAILURE: "token-refresh-failure",
  UNAUTHORIZED_ACCESS: "unauthorized-access",
  NETWORK_ERROR: "network-error",

  // Email Actions  
  EMAIL_SEND_ATTEMPT: "email-send-attempt",
  EMAIL_SEND_SUCCESS: "email-send-success",
  EMAIL_SEND_FAILURE: "email-send-failure",

  // Contact/Feedback Actions
  FEEDBACK_SUBMISSION_ATTEMPT: "feedback-submission-attempt",
  FEEDBACK_SUBMISSION_SUCCESS: "feedback-submission-success",
  FEEDBACK_SUBMISSION_FAILURE: "feedback-submission-failure",

  // Session Management Actions
  SESSION_CHECK_ATTEMPT: "session-check-attempt",
  SESSION_CHECK_SUCCESS: "session-check-success",
  SESSION_CHECK_FAILURE: "session-check-failure",
  SESSION_SYNC_FAILURE: "session-sync-failure",
  SESSION_VISIBILITY_CHANGE: "session-visibility-change",
  SESSION_INTERVAL_START: "session-interval-start",
  SESSION_INTERVAL_STOP: "session-interval-stop",
  SESSION_LIFECYCLE_EVENT: "session-lifecycle-event",

  // User Management Actions  
  SUBSCRIPTION_SELECTION: "subscription-selection",
  SUBSCRIPTION_DATA_FETCH_ATTEMPT: "subscription-data-fetch-attempt",
  SUBSCRIPTION_DATA_FETCH_SUCCESS: "subscription-data-fetch-success",
  SUBSCRIPTION_DATA_FETCH_FAILURE: "subscription-data-fetch-failure",
  VESSEL_IMAGE_FETCH_ATTEMPT: "vessel-image-fetch-attempt",
  VESSEL_IMAGE_FETCH_SUCCESS: "vessel-image-fetch-success",
  VESSEL_IMAGE_FETCH_FAILURE: "vessel-image-fetch-failure",
  USER_AUTHORIZATION_SUCCESS: "user-authorization-success",
  USER_AUTHORIZATION_FAILURE: "user-authorization-failure",

  // Rate Limit Actions
  RATE_LIMIT_CHECK_ATTEMPT: "rate-limit-check-attempt",
  RATE_LIMIT_CHECK_SUCCESS: "rate-limit-check-success",
  RATE_LIMIT_CHECK_FAILURE: "rate-limit-check-failure",
  RATE_LIMIT_VIOLATION_DETECTED: "rate-limit-violation-detected",
  RATE_LIMIT_VIOLATION_EXPIRED: "rate-limit-violation-expired",
  RATE_LIMIT_API_RETRY: "rate-limit-api-retry",

  // Alert System Actions
  ALERT_SHOW: "alert-show",
  ALERT_HIDE: "alert-hide",
  ALERT_AUTO_DISMISS: "alert-auto-dismiss",
  ALERT_USER_DISMISS: "alert-user-dismiss",
  ALERT_CLEAR_ALL: "alert-clear-all",
  ALERT_INTERACTION: "alert-interaction",

  // Date Range Feature Actions
  DATE_RANGE_SELECTION: "date-range-selection",
  DATE_RANGE_SLIDER_CHANGE: "date-range-slider-change",
  DATE_RANGE_FORM_SUBMIT: "date-range-form-submit",
  DATE_RANGE_FORM_VALIDATION: "date-range-form-validation",
  DATE_RANGE_VALIDATION_FAILURE: "date-range-validation-failure",
  DATE_RANGE_CALCULATION: "date-range-calculation",
  VESSEL_LOCATION_DATE_CHANGE: "vessel-location-date-change",
  ANALYSIS_DATE_RANGE_CHANGE: "analysis-date-range-change",

  // User Info Actions
  USER_INFO_FETCH_ATTEMPT: "user-info-fetch-attempt",
  USER_INFO_FETCH_SUCCESS: "user-info-fetch-success",
  USER_INFO_FETCH_FAILURE: "user-info-fetch-failure",

  // Authentication Hook Actions
  AUTH_CHECK_FAILURE: "auth-check-failure",
  AUTH_STATUS_CHANGE: "auth-status-change",

  // Invitation Actions
  INVITE_VALIDATION_ATTEMPT: "invite-validation-attempt",
  INVITE_VALIDATION_SUCCESS: "invite-validation-success",
  INVITE_VALIDATION_FAILURE: "invite-validation-failure",
  INVITE_ACCEPT_ATTEMPT: "invite-accept-attempt",
  INVITE_ACCEPT_SUCCESS: "invite-accept-success",
  INVITE_ACCEPT_FAILURE: "invite-accept-failure",
  INVITE_PASSWORD_VALIDATION_FAILURE: "invite-password-validation-failure",

  // General Navigation Actions
  NAVIGATION_SUCCESS: "navigation-success",
  COMPONENT_MOUNT: "component-mount",
  COMPONENT_ERROR: "component-error",
  USER_INTERACTION: "user-interaction",

  // User Guide Actions
  USER_GUIDE_MODAL_OPEN: "user-guide-modal-open",
  USER_GUIDE_MODAL_CLOSE: "user-guide-modal-close",
  USER_GUIDE_VIDEO_SELECT: "user-guide-video-select",
  USER_GUIDE_VIDEO_PLAY: "user-guide-video-play",
  USER_GUIDE_VIDEO_PAUSE: "user-guide-video-pause",
  USER_GUIDE_VIDEO_COMPLETE: "user-guide-video-complete",

  // Green Feature Actions
  GREEN_DATA_FETCH_ATTEMPT: "green-data-fetch-attempt",
  GREEN_DATA_FETCH_SUCCESS: "green-data-fetch-success", 
  GREEN_DATA_FETCH_FAILURE: "green-data-fetch-failure",
  GREEN_ENVIRONMENTAL_CREDENTIALS_LOAD: "green-environmental-credentials-load",
  GREEN_ROLLING_AER_VALUES_LOAD: "green-rolling-aer-values-load",
  GREEN_EMISSIONS_DATA_LOAD: "green-emissions-data-load",
  GREEN_CII_ALIGNMENT_LOAD: "green-cii-alignment-load",

  // KPIs Feature Actions
  KPI_DATA_FETCH_ATTEMPT: "kpi-data-fetch-attempt",
  KPI_DATA_FETCH_SUCCESS: "kpi-data-fetch-success",
  KPI_DATA_FETCH_FAILURE: "kpi-data-fetch-failure",
  KPI_PHASE_PERCENTAGES_LOAD: "kpi-phase-percentages-load",
  KPI_PHASE_COUNTS_LOAD: "kpi-phase-counts-load",
  KPI_SPEED_RANGES_LOAD: "kpi-speed-ranges-load",
  KPI_KEY_METRICS_LOAD: "kpi-key-metrics-load",
  KPI_VESSEL_COHORT_LOAD: "kpi-vessel-cohort-load",

  // DCF Feature Actions
  DCF_DATA_FETCH_ATTEMPT: "dcf-data-fetch-attempt",
  DCF_DATA_FETCH_SUCCESS: "dcf-data-fetch-success",
  DCF_DATA_FETCH_FAILURE: "dcf-data-fetch-failure",
  DCF_VALUE_CALCULATION: "dcf-value-calculation",
  DCF_VESSEL_LIST_LOAD: "dcf-vessel-list-load",
  DCF_SUMMARY_LOAD: "dcf-summary-load",

  // Value Feature Actions  
  VALUE_DATA_FETCH_ATTEMPT: "value-data-fetch-attempt",
  VALUE_DATA_FETCH_SUCCESS: "value-data-fetch-success",
  VALUE_DATA_FETCH_FAILURE: "value-data-fetch-failure",
  VALUE_MSI_VALUE_CALCULATION: "value-msi-value-calculation",
  VALUE_RECENT_SALES_LOAD: "value-recent-sales-load",
  VALUE_SUMMARY_LOAD: "value-summary-load",

  // Portfolio Feature Actions
  PORTFOLIO_CREATE_ATTEMPT: "portfolio-create-attempt",
  PORTFOLIO_CREATE_SUCCESS: "portfolio-create-success",
  PORTFOLIO_CREATE_FAILURE: "portfolio-create-failure",
  PORTFOLIO_UPDATE_ATTEMPT: "portfolio-update-attempt",
  PORTFOLIO_UPDATE_SUCCESS: "portfolio-update-success",
  PORTFOLIO_UPDATE_FAILURE: "portfolio-update-failure",
  PORTFOLIO_DELETE_ATTEMPT: "portfolio-delete-attempt", 
  PORTFOLIO_DELETE_SUCCESS: "portfolio-delete-success",
  PORTFOLIO_DELETE_FAILURE: "portfolio-delete-failure",
  PORTFOLIO_LOAD_ATTEMPT: "portfolio-load-attempt",
  PORTFOLIO_LOAD_SUCCESS: "portfolio-load-success",
  PORTFOLIO_LOAD_FAILURE: "portfolio-load-failure",
  PORTFOLIO_VESSELS_LOAD: "portfolio-vessels-load",

  // Filter Feature Actions  
  FILTER_DATA_FETCH_ATTEMPT: "filter-data-fetch-attempt",
  FILTER_DATA_FETCH_SUCCESS: "filter-data-fetch-success",
  FILTER_DATA_FETCH_FAILURE: "filter-data-fetch-failure",
  FILTER_CREATE_ATTEMPT: "filter-create-attempt",
  FILTER_CREATE_SUCCESS: "filter-create-success",
  FILTER_CREATE_FAILURE: "filter-create-failure",
  FILTER_UPDATE_ATTEMPT: "filter-update-attempt",
  FILTER_UPDATE_SUCCESS: "filter-update-success", 
  FILTER_UPDATE_FAILURE: "filter-update-failure",
  FILTER_DELETE_ATTEMPT: "filter-delete-attempt",
  FILTER_DELETE_SUCCESS: "filter-delete-success",
  FILTER_DELETE_FAILURE: "filter-delete-failure",
  FILTER_APPLY_ATTEMPT: "filter-apply-attempt",
  FILTER_APPLY_SUCCESS: "filter-apply-success",
  FILTER_APPLY_FAILURE: "filter-apply-failure",  // Download Feature Actions
  DOWNLOAD_INITIATE: "download-initiate",
  DOWNLOAD_SUCCESS: "download-success",
  DOWNLOAD_FAILURE: "download-failure",
  DOWNLOAD_REPORT_GENERATE: "download-report-generate",
  DOWNLOAD_ACTIVITY_REPORT: "download-activity-report",
  DOWNLOAD_VOYAGES_REPORT: "download-voyages-report",
  DOWNLOAD_PORT_CALLS_REPORT: "download-port-calls-report",
  DOWNLOAD_STOPPAGE_EVENTS_REPORT: "download-stoppage-events-report",
  DOWNLOAD_AREA_STATISTICS: "download-area-statistics",

  // Search Feature Actions
  SEARCH_MODAL_OPEN: "search-modal-open",
  SEARCH_MODAL_CLOSE: "search-modal-close", 
  SEARCH_INPUT_CHANGE: "search-input-change",
  SEARCH_QUERY_SUBMIT: "search-query-submit",
  SEARCH_ENTITY_SELECT: "search-entity-select",
  SEARCH_VESSEL_SELECT: "search-vessel-select",
  SEARCH_PORT_SELECT: "search-port-select",
  SEARCH_PORTFOLIO_SELECT: "search-portfolio-select",
  SEARCH_FILTER_SELECT: "search-filter-select",
  SEARCH_OWNERSHIP_SELECT: "search-ownership-select",
  SEARCH_SECTOR_SELECT: "search-sector-select",
  SEARCH_RECENT_CLEAR: "search-recent-clear",
  SEARCH_RECENT_SELECT: "search-recent-select",
  SEARCH_OPTIONS_CHANGE: "search-options-change",
  SEARCH_WORKER_INIT: "search-worker-init",
  SEARCH_WORKER_MESSAGE: "search-worker-message",

  // Main Map Feature Actions
  MAP_VESSEL_CLICK: "map-vessel-click",
  MAP_VESSEL_SELECT: "map-vessel-select",
  MAP_VESSEL_DETAIL_VIEW: "map-vessel-detail-view",
  MAP_ZOOM_CHANGE: "map-zoom-change",
  MAP_LAYER_CHANGE: "map-layer-change",
  MAP_STYLE_CHANGE: "map-style-change",
  MAP_POLYGON_TOGGLE: "map-polygon-toggle",
  MAP_POPUP_OPEN: "map-popup-open",
  MAP_POPUP_CLOSE: "map-popup-close",
  MAP_FLY_TO_POSITION: "map-fly-to-position",
  MAP_MOUSE_HOVER: "map-mouse-hover",
  MAP_LOAD_COMPLETE: "map-load-complete",
  MAP_STYLE_LOAD_COMPLETE: "map-style-load-complete",
  MAP_DATA_LOAD: "map-data-load",
  MAP_VESSEL_ACTIVITY_FETCH: "map-vessel-activity-fetch",
  MAP_SIGNAL_DATA_LOAD: "map-signal-data-load",
  MAP_VOYAGE_DATA_LOAD: "map-voyage-data-load",
  MAP_PORT_CALLS_LOAD: "map-port-calls-load",
  MAP_STOPPAGE_EVENTS_LOAD: "map-stoppage-events-load",
  MAP_DAILY_POSITIONS_LOAD: "map-daily-positions-load",
  MAP_POLYGONS_LOAD: "map-polygons-load",
  MAP_DATE_RANGE_INIT: "map-date-range-init",
  MAP_DATA_FETCH_ATTEMPT: "map-data-fetch-attempt",
  MAP_DATA_FETCH_SUCCESS: "map-data-fetch-success",
  MAP_DATA_FETCH_FAILURE: "map-data-fetch-failure"
} as const;

// Component Names for consistent tracking
export const AppInsightsComponents = {
  LOGIN: "Login",
  LOGOUT: "Logout",
  REGISTER: "Register",
  FORGOT_PASSWORD: "ForgotPassword",
  CHANGE_PASSWORD: "ChangePassword",
  PRODUCT_SELECTION: "ProductSelection",
  CONTACT_US_MODAL: "ContactUsModal",
  USER_GUIDE: "UserGuide",
  USER_GUIDE_MODAL: "UserGuideModal",
  EMAIL_SERVICE: "EmailService",
  USER_PROFILE_MENU: "UserProfileMenu",
  AXIOS_INTERCEPTOR: "AxiosInterceptor",
  AXIOS_SEASCAPE_INTERCEPTOR: "AxiosSeascapeInterceptor",
  USE_AUTH_HOOK: "useAuth",
  HUMAN_VERIFICATION_HOOK: "useHumanVerification",
  NAVIGATION_TRACKER: "NavigationTracker",
  ACTIVITY_LOG_API: "ActivityLogApi",
  SESSION_SYNC_HOOK: "useSessionSync",
  RATE_LIMIT_HOOK: "useRateLimitViolation",
  SHARED_ALERTS_HOOK: "useSharedAlerts",
  SESSION_SYNC: "SessionSync",
  DATE_RANGE_SLIDER: "DateRangeSlider",
  DATE_RANGE_FORM: "DateRangeForm",
  DATE_RANGE_WITH_SLIDER: "DateRangeWithSlider",
  DATE_RANGE_HELPERS: "DateRangeHelpers",
  DATE_RANGE_SLICE: "DateRangeSlice",
  PRODUCT_LAYOUT: "ProductLayout",
  USER_ACCESS_LAYOUT: "UserAccessLayout",
  AXIOS_INSTANCE: "AxiosInstance",
  AXIOS_SEASCAPE_INSTANCE: "AxiosSeascapeInstance",
  INVITE_PAGE: "InvitePage",
  USE_INVITATION_HOOK: "useInvitation",
  INVITE_API: "InviteApi",

  // Feature Components
  GREEN_COMPONENT: "Green",
  GREEN_OVERVIEW: "GreenOverview",
  GREEN_COHORT_EMISSIONS: "GreenCohortEmissions", 
  GREEN_ENVIRONMENTAL_CREDENTIALS: "GreenEnvironmentalCredentials",
  KPI_COMPONENT: "Kpi",
  KPI_OVERVIEW: "KpiOverview",
  KPI_DEPLOYMENT: "KpiDeployment",
  KPI_COHORT_BENCHMARKING: "KpiCohortBenchmarking",
  DCF_COMPONENT: "Dcf",
  DCF_VESSEL_DCF: "DcfVesselDcf",
  DCF_SUMMARY: "DcfSummary",
  VALUE_COMPONENT: "Value",
  VALUE_VESSEL_MSI_VALUE: "ValueVesselMsiValue",
  VALUE_SUMMARY: "ValueSummary",
  PORTFOLIO_COMPONENT: "Portfolio",
  PORTFOLIO_DETAIL_PANEL: "PortfolioDetailPanel",
  PORTFOLIO_MANAGEMENT: "PortfolioManagement",
  FILTER_COMPONENT: "Filter",
  FILTER_PANEL: "FilterPanel",
  FILTER_MANAGEMENT: "FilterManagement",
  DOWNLOAD_COMPONENT: "Download",
  DOWNLOAD_REPORT_GENERATOR: "DownloadReportGenerator",
  DOWNLOAD_ACTIVITY_REPORT: "DownloadActivityReport",

  // Main Map Components
  MAP_BOX_COMPONENT: "MapBox",
  MAP_CONTAINER: "MapContainer",
  VESSEL_POPUP: "VesselPopup",
  MAP_CONTROLS: "MapControls",
  MAP_LAYERS: "MapLayers",
  MAP_SAGA: "MapSaga",

  // Security Components
  TURNSTILE_WIDGET: "TurnstileWidget",
  RECAPTCHA_WIDGET: "RecaptchaWidget", 
  HUMAN_VERIFICATION_WIDGET: "HumanVerificationWidget",
  HUMAN_VERIFICATION_PROVIDER: "HumanVerificationProvider",
  HUMAN_VERIFICATION_SERVICE: "HumanVerificationService",
  HUMAN_VERIFICATION_CONFIG: "HumanVerificationConfig",
  SECURITY_CONFIG: "SecurityConfig",

  // Global Services
  GLOBAL_ALERT_SERVICE: "GlobalAlertService",

  // User Management Components
  USER_MANAGEMENT_APP: "UserManagementApp",
  USER_MANAGEMENT_SLICE: "UserManagementSlice",
  USER_MANAGEMENT_SAGA: "UserManagementSaga",
  AUTH_API: "AuthApi",
  SUBSCRIPTION_API: "SubscriptionApi",

  // Search Feature Components
  SEARCH_COMPONENT: "Search",
  SEARCH_MODAL: "SearchModal",
  SEARCH_WORKER: "SearchWorker",
  SEARCH_SLICE: "SearchSlice",

  // Main Map Feature Components
  MAIN_MAP: "MainMap",
  MAP_BOX: "MapBox",
  MAP_STYLE_CHANGER: "MapStyleChanger",
  MAP_LAYER_CHANGER: "MapLayerChanger",
  MAP_LEGEND_INFO: "MapLegendInfo",
  POLYGON_LAYER_TOGGLE: "PolygonLayerToggle",
  VESSEL_POPUP_SUMMARY: "VesselPopupSummary",
  SIGNAL_POPUP_CONTENT: "SignalPopupContent",
  SIGNAL_HOVER_POPUP_CONTENT: "SignalHoverPopupContent",
  VOYAGE_HOVER_POPUP_CONTENT: "VoyageHoverPopupContent",
  
  // Map Redux Slices
  VESSELS_LAST_SIGNAL_SLICE: "VesselsLastSignalSlice",
  VESSEL_LAST_VOYAGES_SLICE: "VesselLastVoyagesSlice",
  VESSEL_LAST_STOPPAGE_EVENTS_SLICE: "VesselLastStoppageEventsSlice",
  VESSEL_LAST_PORT_CALLS_SLICE: "VesselLastPortCallsSlice",
  VESSEL_DAILY_POSITIONS_SLICE: "VesselDailyPositionsSlice",
  VESSEL_ONGOING_VOYAGE_SIGNALS_SLICE: "VesselOngoingVoyageSignalsSlice",
  VESSEL_VOYAGE_DAILY_SIGNALS_SLICE: "VesselVoyageDailySignalsSlice",
  VESSEL_CURRENT_STATUS_SLICE: "VesselCurrentStatusSlice",
  DETAILED_POLYGONS_SLICE: "DetailedPolygonsSlice",
  DEFAULT_ACTIVITY_DATE_RANGE_SLICE: "DefaultActivityDateRangeSlice"
} as const;

// Error Types for consistent categorization
export const AppInsightsErrorTypes = {
  API_ERROR: "api-error",
  NETWORK_ERROR: "network-error",
  VALIDATION_ERROR: "validation-error",
  AUTHENTICATION_ERROR: "authentication-error",
  HUMAN_VERIFICATION_ERROR: "human-verification-error",
  FORM_SUBMISSION_ERROR: "form-submission-error",
  EMAIL_SERVICE_ERROR: "email-service-error",
  AUTH_ERROR: "auth-error",
  AUTHORIZATION_ERROR: "authorization-error",
  CONFIGURATION_ERROR: "configuration-error",
  UNEXPECTED_ERROR: "unexpected-error",
  USER_INPUT_ERROR: "user-input-error",
  EXTERNAL_SERVICE_ERROR: "external-service-error",
  INVITE_VALIDATION_ERROR: "invite-validation-error",
  INVITE_EXPIRED_ERROR: "invite-expired-error", 
  INVITE_USED_ERROR: "invite-used-error",
  INVITE_REVOKED_ERROR: "invite-revoked-error",

  // Feature-specific Errors
  GREEN_DATA_ERROR: "green-data-error",
  GREEN_CALCULATION_ERROR: "green-calculation-error",
  KPI_DATA_ERROR: "kpi-data-error", 
  KPI_CALCULATION_ERROR: "kpi-calculation-error",
  DCF_CALCULATION_ERROR: "dcf-calculation-error",
  DCF_DATA_ERROR: "dcf-data-error",
  VALUE_CALCULATION_ERROR: "value-calculation-error",
  VALUE_DATA_ERROR: "value-data-error",
  PORTFOLIO_CRUD_ERROR: "portfolio-crud-error",
  PORTFOLIO_VALIDATION_ERROR: "portfolio-validation-error",
  FILTER_CRUD_ERROR: "filter-crud-error",
  FILTER_VALIDATION_ERROR: "filter-validation-error",
  FILTER_APPLICATION_ERROR: "filter-application-error",
  DOWNLOAD_GENERATION_ERROR: "download-generation-error",
  DOWNLOAD_FILE_ERROR: "download-file-error",
  SESSION_SYNC_ERROR: "session-sync-error",
  RATE_LIMIT_ERROR: "rate-limit-error",
  ALERT_SYSTEM_ERROR: "alert-system-error",
  DATE_RANGE_PARSING_ERROR: "date-range-parsing-error",
  DATE_RANGE_CALCULATION_ERROR: "date-range-calculation-error",
  MAP_DATA_ERROR: "map-data-error",
  DATE_CONVERSION_ERROR: "date-conversion-error",
  DATE_RANGE_VALIDATION_ERROR: "date-range-validation-error",
  DATE_RANGE_SLIDER_ERROR: "date-range-slider-error",

  // Search Feature Errors
  SEARCH_WEB_WORKER_ERROR: "search-web-worker-error",
  SEARCH_ENTITY_NOT_FOUND_ERROR: "search-entity-not-found-error",
  SEARCH_VESSEL_NOT_FOUND_ERROR: "search-vessel-not-found-error",
  SEARCH_PORTFOLIO_NOT_FOUND_ERROR: "search-portfolio-not-found-error",
  SEARCH_FILTER_NOT_FOUND_ERROR: "search-filter-not-found-error",
  SEARCH_INPUT_VALIDATION_ERROR: "search-input-validation-error",
  SEARCH_RECENT_STORAGE_ERROR: "search-recent-storage-error",
  SEARCH_MODAL_INTERACTION_ERROR: "search-modal-interaction-error",
  SEARCH_SELECTION_ERROR: "search-selection-error",

  // Main Map Feature Errors
  MAP_INITIALIZATION_ERROR: "map-initialization-error",
  MAP_STYLE_LOAD_ERROR: "map-style-load-error",
  MAP_DATA_FETCH_ERROR: "map-data-fetch-error",
  MAP_VESSEL_DATA_ERROR: "map-vessel-data-error",
  MAP_SIGNAL_DATA_ERROR: "map-signal-data-error",
  MAP_VOYAGE_DATA_ERROR: "map-voyage-data-error",
  MAP_PORT_CALLS_DATA_ERROR: "map-port-calls-data-error",
  MAP_STOPPAGE_DATA_ERROR: "map-stoppage-data-error",
  MAP_DAILY_POSITIONS_ERROR: "map-daily-positions-error",
  MAP_POLYGON_DATA_ERROR: "map-polygon-data-error",
  MAP_INTERACTION_ERROR: "map-interaction-error",
  MAP_POPUP_ERROR: "map-popup-error",
  MAP_FLY_TO_ERROR: "map-fly-to-error",
  MAP_ZOOM_ERROR: "map-zoom-error",
  MAP_LAYER_ERROR: "map-layer-error",
  MAP_STYLE_CHANGE_ERROR: "map-style-change-error",
  MAP_DATE_RANGE_ERROR: "map-date-range-error",
  MAP_SUBSCRIPTION_ERROR: "map-subscription-error",

  // Security Feature Errors
  TURNSTILE_SCRIPT_LOAD_ERROR: "turnstile-script-load-error",
  TURNSTILE_RENDER_ERROR: "turnstile-render-error",
  TURNSTILE_VERIFICATION_ERROR: "turnstile-verification-error",
  TURNSTILE_WIDGET_ERROR: "turnstile-widget-error",
  RECAPTCHA_SCRIPT_LOAD_ERROR: "recaptcha-script-load-error",
  RECAPTCHA_RENDER_ERROR: "recaptcha-render-error",
  RECAPTCHA_VERIFICATION_ERROR: "recaptcha-verification-error",
  RECAPTCHA_EXECUTION_ERROR: "recaptcha-execution-error",
  RECAPTCHA_WIDGET_ERROR: "recaptcha-widget-error",
  RECAPTCHA_INITIALIZATION_ERROR: "recaptcha-initialization-error",
  HUMAN_VERIFICATION_CONFIG_ERROR: "human-verification-config-error",
  HUMAN_VERIFICATION_PROVIDER_ERROR: "human-verification-provider-error",
  HUMAN_VERIFICATION_UNSUPPORTED_PROVIDER_ERROR: "human-verification-unsupported-provider-error",
  SECURITY_CONFIGURATION_ERROR: "security-configuration-error",
  SECURITY_VALIDATION_ERROR: "security-validation-error",

  // Global Service Errors
  ALERT_SERVICE_UNAVAILABLE_ERROR: "alert-service-unavailable-error",

  // User Management Errors
  USER_MANAGEMENT_ERROR: "user-management-error",
  USER_AUTHENTICATION_ERROR: "user-authentication-error",
  SUBSCRIPTION_ERROR: "subscription-error",
  VESSEL_DATA_ERROR: "vessel-data-error",
  USER_INFO_ERROR: "user-info-error"
} as const;

// Navigation Reasons for Product Selection
export const AppInsightsNavigationReasons = {
  SINGLE_PRODUCT_SEASCAPE_DESKTOP: "single-product-seascape-desktop",
  SINGLE_PRODUCT_HORIZON_OR_MOBILE: "single-product-horizon-or-mobile", 
  MANUAL_SELECTION_SEASCAPE: "manual-selection-seascape",
  MANUAL_SELECTION_HORIZON: "manual-selection-horizon"
} as const;

// Type exports for TypeScript support
export type AppInsightsAction = typeof AppInsightsActions[keyof typeof AppInsightsActions];
export type AppInsightsComponent = typeof AppInsightsComponents[keyof typeof AppInsightsComponents];
export type AppInsightsErrorType = typeof AppInsightsErrorTypes[keyof typeof AppInsightsErrorTypes];
export type AppInsightsNavigationReason = typeof AppInsightsNavigationReasons[keyof typeof AppInsightsNavigationReasons];